import { render, staticRenderFns } from "./userSettingsIndex.pug?vue&type=template&id=55b305dc&lang=pug&"
import script from "./userSettingsIndex.ts?vue&type=script&lang=ts&"
export * from "./userSettingsIndex.ts?vue&type=script&lang=ts&"
import style0 from "./userSettingsIndex.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports